import { render } from "./comp-entity.vue?vue&type=template&id=03f4671a&ts=true"
import script from "./comp-entity.vue?vue&type=script&lang=ts"
export * from "./comp-entity.vue?vue&type=script&lang=ts"

import "./comp-entity.vue?vue&type=style&index=0&id=03f4671a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__